<form *ngIf="formConfig.parentForm"
	nz-form [formGroup]="formConfig.parentForm" id="{{formID}}"
	(ngSubmit)="submitForm()" [nzLayout]="'horizontal'" (change)="change($event)"
	autocomplete="off"
>
	<app-card-style-object-renderer
			[property]="[]"
			[schema]="resolvedSchema"
			[data]="data"
			[formConfig]="formConfig"
			[required]="required"
			(valid)="isFormValid()"
	>
	</app-card-style-object-renderer>
</form>
